import React, { Component } from 'react'
import { Navbar,Nav
} from 'react-bootstrap';
import { ApiService } from 'services';
import {Link} from 'react-router-dom'
import './NavigationBar.css'
import styled from 'styled-components'

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class NavigationBar3 extends Component {

    constructor(props) {
    super(props);
   // this.eosio = new EOSIOClient("smartshop");
    this.state={
      data:'mil'
    }

    }
    
 componentDidMount()
 {
   this.handleState()
 }   
handleState=()=>
{
  const name =localStorage.getItem("account_name")
  //console.log("t",name)
  this.setState({
    data:'jik'
  })
  if(name)
     {
       return
     }
  sleep(500).then(() => {
    this.handleState()
     })
     
}

  handleShow=()=> {
try{  
  
     sleep(500).then(() => {
    console.log("you clicked")
    //this.eosio.login()
this.props.eosio2.login()
     })

    }
    catch(err)
    {
      console.log(err)
      alert("Unable to find scatter 1")
    } 
     }

  handleLogoutClick()
  {
    return ApiService.logOut()
       
  }


  render() {

      const name =localStorage.getItem("account_name")
      
    return (
      <ProductWrapper>
  <Navbar collapseOnSelect expand="lg" bg="dark"  variant="dark" fixed="top">
  <Link to='/'><Navbar.Brand  className="brand">Cafeteria</Navbar.Brand></Link>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">
      <Nav.Link href="#pricing"></Nav.Link>
      
    </Nav>
    <Nav>


    <Nav.Link >
      {name}
      </Nav.Link>


  <Link className="nav_item" to= '/uploadedData'>My Items </Link>

      
           
      
      <Link className="nav_item" to= '/upload'>Add Item </Link>

      <Link className="cart_btn" to= '/cart'> <i className="fas fa-cart-plus"/> Cart </Link>
          
      {/* <Nav.Link onClick={this.handleShow}>
      Log in
      </Nav.Link> */}
      <Nav.Link >
        {/* <Link to ='/cart'> */}
      {/* {name?'Logout':'Login'} */}
      {name ? (
        <button onClick={this.handleLogoutClick} >Logout</button>
      ) : (
        <button 
        onClick={this.handleShow} >Login</button>
      )}
      {/* </Link> */}
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>

  
</ProductWrapper>

      
      
    )
  }
}

// const mapStateToProps = state => state;
// // Map the following action to props
// const mapDispatchToProps ={}
// // Export a redux connected component
// export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar3);

export default NavigationBar3

const ProductWrapper=styled.div`

  
.cart_btn{
   
    border: none;
    color: var(--lightWhite);
}

.brand{
  color: var(--mainWhite);
}

  
`;
